// @ts-ignore
import styled from 'styled-components';

import { flex } from 'components/BaseComponentStyles';

// @ts-ignore
export const AnchorNoUnderline = styled.a`
  ${flex};
  text-decoration: none;
`;
